import HeroSection from "./components/HeroSection";
import MissionSection from "./components/MissionSection";
import PrinciplesSection from "./components/PrinciplesSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <main>
      <HeroSection />
      <MissionSection />
      <PrinciplesSection />
      <ContactSection />
    </main>
  );
}